import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { infoData } from '../../common/utils/constant';
import './audience.scss';
import InfoBox from './components/infoBox';
import ContentSection from './components/contentSection';
import { SectionWrapper } from '../../theme/layouts/MainLayout';
import { altLtGray, techBlack } from '../../common/utils/constant';
import AppImage from '../../common/features/image';

const Audience = () => {

  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const textContent = `Best Buy Ads, in partnership with the Best Buy Foundation, is launching an advertising-focused Career Pathway program in Best Buy Teen Tech Center™ locations—helping to strengthen skills used in the advertising industry. The goal of the program is to create opportunities and a pipeline of talented and diverse candidates for future advertising careers. Our advertising partners will have an opportunity to get involved by offering mentorship, internships and career placements for teens in the program.`;

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className='audience-wrapper layer'>
      <SectionWrapper bg={techBlack} >
        <section className="audience-section-1">
          <Row>
            <Col md={6} sm={12}>
              <div className="audience-column">
                <div className="audience-title">Make every connection count.</div>
                <div className="heading-subtext">Our customers trust us to deliver the right products as they imagine, try and buy.
                  With Best Buy Ads, your brand is there for every step of the journey.</div>
              </div>
            </Col>
            <Col md={6} sm={12} className='teentech-img'>
              <AppImage src={isMobile ? '/images/audience/audiences_hero_mobile.png' : '/images/audience/audiences_hero.png'} alt='Make every connection count' title='Make every connection count' className='aud-img-style' />
            </Col>
          </Row>
        </section>
      </SectionWrapper>

      <section className='background-section-2'>

        <SectionWrapper bg={altLtGray}>
          <section className='aud-section-2'>
            <Row>
              <Col md={7} sm={12} className=''>
                <div className='left-section-2'>
                  We’re the go-to for <span className='energy-purple'>all</span> things tech.</div>

              </Col>
              <Col md={5} sm={12} className='d-flex justify-content-center align-items-center'>
                <div className='right-section-2'>
                  When people think tech, they think Best Buy. We’re with them for whatever they’re looking to get into with
                  trusted advice, products and service.
                </div>

              </Col>
            </Row>
          </section>
        </SectionWrapper>
        <Row className='bg-tech-img'>
          <Col md={12} className="background-img-section" onContextMenu={(e) => e.preventDefault()}>
          </Col>
        </Row>
      </section>

      <SectionWrapper bg={techBlack}>
        <section className='background-section-3'>
          <Row>
            <Col md={12} className=''>
              <div className='text-section-3'>
                Online, in-person and everywhere you go.
              </div>

            </Col>
            <Col md={7} sm={12} className=''>
              <div className='num-section-3'>
                200M+ </div>
            </Col>
            <Col md={5} sm={12} className='d-flex justify-content-center align-items-center'>
              <div className='subtext-section-3'>
                Customers. That's more than 70% of the US adult population. </div>
            </Col>

            <Col md={4} sm={12} className='aud-stat-box'>
              <div className='box-title-section-3'>Online</div>
              <div className='box-num-section-3'>
                10B+ </div>
              <div className='box-subtext-section-3'>site page views per year</div>
            </Col>
            <Col md={4} sm={12} className='aud-stat-box'>
              <div className='box-title-section-3'>In-Store</div>
              <div className='box-num-section-3'>
                40% </div>
              <div className='box-subtext-section-3'>of online sales picked up in store</div>
            </Col>
            <Col md={4} sm={12} className='aud-stat-box'>
              <div className='box-title-section-3'>Mobile</div>
              <div className='box-num-section-3'>
                11M+ </div>
              <div className='box-subtext-section-3'>unique mobile app users</div>
            </Col>

            <Col md={12} className=''>
              <div className="audience-data-source-link">
                <div onClick={handleToggle} id="dataId" className='data-source-link'>
                   Data sources
                  {isOpen ? <img src={'/images/common/icons/cheveron-yellow-up.png'} alt="Down Icon" title='Down Icon' /> : <img src={'/images/common/icons/cheveron-yellow-down.png'} alt="Up Icon" title='Up Icon' />}
                </div>

                <div className={`aud-expand-text ${isOpen ? 'open-aud' : 'close-aud'}`}>
                  <p>Internal Best Buy data ’22-’23</p>
                </div>
              </div>
            </Col>
          </Row>
        </section>
      </SectionWrapper>

      <SectionWrapper bg={altLtGray}>
        <section className='background-section-4 py-64'>
          <Row>

            <Col md={6} sm={12}>
              <AppImage src={isMobile ? '/images/audience/audiences_trust_graphic_mobile.svg' : '/images/audience/audiences_trust_graphic.svg'} alt='A customer journey built on trust.' title='A customer journey built on trust.' className='img-fit-style' />
            </Col>

            <Col md={6} sm={12}>
              <div className='audience-section-4-title'>
                A customer journey built on <span className='energy-purple'>trust.</span></div>
            </Col>

          </Row>
        </section>
        <section className='info-section-style'>
          <Row>
            {infoData.map((info, index) => (
              <InfoBox key={index} title={info.title} text={info.text} />
            ))}
          </Row>
        </section>

      </SectionWrapper>

      <SectionWrapper bg={altLtGray}>
        <section className="audience-section-3">
          <ContentSection
            titleText={'We are committed to building a more'}
            highlightedText={'equitable future.'}
            text={textContent}
            imageSrc={isMobile ? '/images/audience/audiences_teen-tech_image_mobile.png' : '/images/audience/audiences_teen-tech_image.png'}
            reverseOrder={true}
            imageClass=""
          />
        </section>
      </SectionWrapper>

    </div>
  )
}

export default Audience;

